import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { BACKEND_SERVER_URL } from '../../../../http/http-config';
import DummyReportModalNew from './DummyReportModalNew';

import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import SearchBox from '../../Common-Components/SearchBox';
import { showTableResponse } from '../../common-helpers/commonServices';
import { getCourses, getSubjects, getTopics, setDropDownStyle } from '../../CommonHelper';



const TopicReports = () => {
  const location = useLocation();
  const childRef = useRef();
  const [reports, setReports] = useState([]);
  const [subjectWisetopics, setSubjectWiseTopics] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);
  const [courseWiseSubjects, setCourseWiseSubjects] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState({ courseTitle: "All Courses" });
  const [selectedSubject, setSelectedSubject] = useState({ subject: "All Subjects" });
  const [selectedTopic, setSelectedTopic] = useState({ title: "All Topics" });

  const [currentPage, setCurrentPage] = useState(1);
  const [checked, setChecked] = useState([]);
  const [loadReports, setReportsLoading] = useState(false);
  //set Table data
  // useEffect(() => {
  //   axios.get(BACKEND_SERVER_URL + '/getLessonReports').then((res) => {
  //     let reports = res.data.reports;  //recieving batch here 
  //     setReports(reports);
  //     setChecked(reports);
  //     // if (reports) {
  //     //   setTotalActiveTopics(reports.filter(batch => batch.status == 1 && batch.hide == 0))
  //     //   setTotalInactiveTopics(reports.filter(batch => batch.status == 0 && batch.hide == 0))
  //     //   let archivedYears = reports.filter(batch => batch.hide == 1)
  //     //   setTotalArchivedTopics(archivedYears)

  //     //   let activeInactiveYears = reports.filter(batch => batch.hide == 0)
  //     //   setTopics(activeInactiveYears);
  //     //   setChecked(activeInactiveYears);
  //     // }
  //   }).catch((error) => {
  //     toast.error(error.response.data.message)
  //   })
  //   getCourses().then((res) => {
  //     res.unshift({ courseTitle: "All Courses" })
  //     setCourses(res)
  //   })
  //   getSubjects().then((res) => {
  //     setSubjects(res)
  //   })
  //   getTopics().then((res) => {
  //     setTopics(res)
  //   })
  // }, [loadReports])
  const pageSize = 20;
  const lastIndex = currentPage * pageSize;
  const firstIndex = lastIndex - pageSize;
  const records = checked?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(checked?.length / pageSize);
  const number = [...Array(npage + 1).keys()].slice(1);

  useEffect(() => {
    return () => {
      if (location.pathname === '/lesson-reports') {
        localStorage.removeItem('reportsSelections');
      }
    };
  }, [location.pathname]);
  useEffect(() => {
    axios.get(BACKEND_SERVER_URL + '/getLessonReports')
      .then((res) => {
        let reports = res.data.reports;
        setReports(reports);
        setChecked(reports);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to load reports");
      });

    getCourses().then((res) => {
      res.unshift({ courseTitle: "All Courses" });
      setCourses(res);
    });

    getSubjects().then((res) => setSubjects(res));
    getTopics().then((res) => setTopics(res));
  }, [loadReports]);

  useEffect(() => {
    const savedSelections = localStorage.getItem('reportsSelections');
    if (!savedSelections) return;

    const {
      preSelectedCourse,
      preSelectedSubject,
      preSelectedTopic,
    } = JSON.parse(savedSelections);

    if (
      preSelectedCourse?.courseTitle === "All Courses" ||
      preSelectedSubject?.subject === "All Subjects" ||
      preSelectedTopic?.title === "All Topics"
    ) return;

    setSelectedCourse(preSelectedCourse);
    setSelectedSubject(preSelectedSubject);
    setSelectedTopic(preSelectedTopic);

    const matchedSubjects = subjects.filter(
      (sub) => sub.courseId === preSelectedCourse.courseId
    );
    matchedSubjects.unshift({ subject: "All Subjects" });
    setCourseWiseSubjects(matchedSubjects);

    const matchedTopics = topics.filter(
      (top) => top.subjectId === preSelectedSubject.sn
    );
    setSubjectWiseTopics(matchedTopics);

    const matchedReports = reports.filter(
      (obj) =>
        obj.sectionId === preSelectedTopic.sectionId ||
        obj.topicId === preSelectedTopic.sn
    );
    setChecked(matchedReports);
  }, [reports, subjects, topics]);

  useEffect(() => {
    if (
      selectedCourse.courseTitle === "All Courses" ||
      selectedSubject.subject === "All Subjects" ||
      selectedTopic.title === "All Topics"
    ) return;

    localStorage.setItem(
      'reportsSelections',
      JSON.stringify({
        preSelectedCourse: selectedCourse,
        preSelectedSubject: selectedSubject,
        preSelectedTopic: selectedTopic,
      })
    );
  }, [selectedCourse, selectedSubject, selectedTopic]);

  const resetFilters = () => {
    setSelectedCourse({ courseTitle: "All Courses" });
    setSelectedSubject({ subject: "All Subjects" });
    setSelectedTopic({ title: "All Topics" });
    setCourseWiseSubjects([]);
    setSubjectWiseTopics([]);
    localStorage.removeItem('reportsSelections');
    setChecked(reports);
  }

  const selectCourseHandler = (selectedCourse) => {
    setSelectedCourse(selectedCourse);
    setSelectedSubject({ subject: "All Subjects" });
    setSelectedTopic({ title: "All Topics" });
    setChecked(reports);

    if (selectedCourse.courseTitle === "All Courses") {
      setCourseWiseSubjects([{ subject: "All Subjects" }]);
      return;
    }

    const filteredSubjects = subjects.filter(
      (subject) => subject.courseId === selectedCourse.courseId
    );
    filteredSubjects.unshift({ subject: "All Subjects" });
    setCourseWiseSubjects(filteredSubjects);
  };

  const selectSubjectHandler = (selectedSubject) => {
    setSelectedSubject(selectedSubject);
    setSelectedTopic({ title: "All Topics" });
    setChecked(reports);

    if (selectedSubject.subject === "All Subjects") return;

    const filteredTopics = topics.filter(
      (topic) => topic.subjectId === selectedSubject.sn
    );
    setSubjectWiseTopics(filteredTopics);
  };

  const selectTopicHandler = (selectedTopic) => {
    setSelectedTopic(selectedTopic);

    const selectedReports = reports.filter(
      (obj) =>
        obj.sectionId === selectedTopic.sectionId ||
        obj.topicId === selectedTopic.sn
    );
    setChecked(selectedReports);
  };





  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                <div className=' col-8  d-flex justify-content-between'>
                  <button type="button" className="btn btn-dark btn-sm me-2"
                    onClick={() => { resetFilters(); childRef.current.openModal() }}
                  >
                    + Add Report
                  </button>
                  <div className="col-3">
                    <div className="basic-dropdown">
                      <Select
                        value={{ value: selectedCourse, label: selectedCourse.courseTitle }}
                        onChange={(selectedOption) => selectCourseHandler(selectedOption.value)}
                        options={courses?.map((course) => ({ value: course, label: course.courseTitle }))}
                        styles={setDropDownStyle()}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="basic-dropdown ms-1">
                      <Select
                        value={{ value: selectedSubject, label: selectedSubject.subject }}
                        onChange={(selectedOption) => selectSubjectHandler(selectedOption.value)}
                        options={courseWiseSubjects?.map((subject) => ({ value: subject, label: subject.subject }))}
                        styles={setDropDownStyle()}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="basic-dropdown ms-1">
                      <Select
                        value={{ value: selectedTopic || "All Topics", label: selectedTopic.title || "All Topics" }}
                        onChange={(selectedOption) => selectTopicHandler(selectedOption.value)}
                        options={subjectWisetopics?.map((item) => ({ value: item, label: item.title }))}
                        styles={setDropDownStyle()}
                      />
                    </div>
                  </div>
                  {/*    <button type="button" className="btn btn-dark btn-xs ms-2 " onClick={handleShowAllCourses}> show All</button> */}
                </div>
                <div className="input-group search-area mb-md-0 mb-3">
                  <SearchBox setChecked={setChecked} dataArray={reports} searchingProperty={'firstName'} />
                </div>
              </div>
              {/* <ProdutsDetailsTabsAtTop setChecked={setChecked} totalItems={topics} totalActiveItems={totalActiveTopics} totalInactiveItems={totalInactiveTopics} totalArchivedItems={totalArchivedTopics} /> */}
            </div>
            <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                {/* <div>
                  <Button variant="danger ms-3" size='xs' onClick={(e) => bulkOperations("delete", records, '/hideTopics', 'Topics', setTopicsLoading, loadTopics)}>Delete</Button>
                  <Button variant="success ms-3 " size='xs' onClick={(e) => bulkOperations("activate", records, '/activateTopics', 'Topics', setTopicsLoading, loadTopics)}>Active</Button>
                  <Button variant="warning ms-3" size='xs' onClick={(e) => bulkOperations("InActivate", records, '/inActivateTopics', 'Topics', setTopicsLoading, loadTopics)}>Inactive</Button>
                </div> */}

                <div className='dataTables_info text-dark'>
                  Records: {checked.length}
                </div>
                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                  id="example-student_wrapper">
                  <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                </div> : null}
              </div>
              <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                  <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                    <thead style={{ backgroundColor: "#cccccc" }}>
                      <tr className='text-center text-dark border border-left'>
                        <th className=' custom-table-header  p-2'>SN</th>
                        <th className='p-2 text-start custom-table-header '>STATUS</th>
                        <th className=' text-start custom-table-header  p-2' >STUDENT NAME</th>
                        <th className=' text-start custom-table-header  p-2' >LESSON</th>
                        <th className='custom-table-header  p-2' >TOTAL Qs.</th>
                        <th className='custom-table-header  p-2' >ATTEMPTED Qs..</th>
                        <th className='custom-table-header  p-2' >NET SCORE</th>
                        <th className='custom-table-header  p-2' >ATTEMPT COUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.length > 0 ? records.map((item, ind) => (
                        <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                          <td className='text-center p-1 column-width ' style={{ border: "1px solid #cccccc", width: "65px" }} ><h6 className="sn-font-weight mb-0" > {item.sn}</h6></td>
                          <td className='text-start p-1 active-col-width' style={{ border: "1px solid #cccccc", width: "80px" }}>
                            {item.status === 'Complete' ? <h6 className="text-success mb-0 "> Complete </h6> : <h6 className="text-danger mb-0"> Incomplete </h6>}

                          </td>
                          <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                            <div className="d-flex justify-content-between">
                              {item.firstName ? (
                                <h6 className='mb-0' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.firstName}</h6>
                              ) : (
                                <h6 className='mb-0 text-secondary' style={{ fontSize: '13px', fontWeight: 'bold' }}>Dummy Report</h6>
                              )}
                            </div>

                          </td>
                          <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.lessonName}</h6>
                          </td>
                          <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }}>
                            <h6 className="mb-0 ">
                              {item.totalQuestions}
                            </h6>
                          </td>
                          <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }}>
                            <h6 className="mb-0 ">
                              {item.attemptedQuestions}
                            </h6>
                          </td>
                          <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }}>
                            <h6 className="mb-0 ">
                              {item.netScore}
                            </h6>
                          </td>
                          <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "80px" }}>
                            <h6 className="mb-0 ">
                              {item.attemptCount}
                            </h6>
                          </td>

                        </tr>
                      )) :
                        <tr>
                          <td colSpan="9" className="text-center">
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                              {
                                showTableResponse(reports, checked)
                              }
                            </div>
                          </td>
                        </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DummyReportModalNew ref={childRef} loadTopics={loadReports} setReportsLoading={setReportsLoading} />
    </>
  )
}

export default TopicReports;

